import { SKOLKOVO_LINK } from '../../../../constants/links';
import SkLogo from '../../../../icons/logo/sk_logo.png';
import { ReactComponent as Arir } from '../../../../icons/logo/arir_grey.svg';
import { ReactComponent as TechIndex } from '../../../../icons/logo/tech-index.svg';
import styles from './tile-info.module.scss';
import cs from 'classnames';
import { useTranslation } from 'react-i18next';

export const TileInfo = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={cs(styles['wrapper'])}>
      <div className={cs(styles['left-side'])}>
        <div className={cs(styles['image'])}>
          <a href={SKOLKOVO_LINK} target="_blank" rel="noreferrer">
            <img className={cs(styles['image'])} src={SkLogo} alt="Logo" />
          </a>
        </div>
        <div className={cs(styles['text'])}>{t('footer.accreditation')}</div>
      </div>
      <div className={cs(styles['logos-group'])}>
        <TechIndex />
        <Arir />
      </div>
    </div>
  );
};
